import { Component, Input, OnInit } from '@angular/core';
import { CustomerFieldDTO } from 'app/public/model/CustomerFieldDto';
import { Roulette } from 'app/public/model/roulette.model';
import { CustomerFields } from 'app/shared/model/enums';

@Component({
  selector: 'app-field-dialog',
  templateUrl: './field-dialog.component.html',
  styleUrl: './field-dialog.component.scss'
})
export class FieldDialogComponent implements OnInit{
  ngOnInit(): void {
   this.customerFields=this.roulette.AdditionalCustomerFields;
   console.log(this.customerFields);
   this.fieldTypes = this.enumToArray(CustomerFields)
  }
  @Input()
  roulette: Roulette;
 customerFields:CustomerFieldDTO[]
 fieldTypes: { label: string; value: number }[] = []; 
displayDialog:boolean=false;
 showDialog()
{
   this.displayDialog=true
}
closeDialog()
{
  this.displayDialog=false
}
enumToArray(enumObj: any)
{
  return Object.keys(enumObj)
  .filter(key => isNaN(Number(key)))
  .map(key => ({ value: enumObj[key], label: key }));
}
updateField(field:CustomerFieldDTO)
{
    this.roulette.AdditionalCustomerFields[field.FieldId]=field
}
}
